import React from "react";
import styles from "./timestamps-and-strings-data-table.module.scss";
import Spinner from "@src/components/atoms/spinner/spinner";
import { useI18N } from "@src/language/language-context";

const cssClassName = "timestamps-and-strings-data-table";

type DataItem<T, U> = {
  timestamp: T;
  data: U;
};

type Props<T, U> = {
  data: DataItem<T, U>[];
};

export const TimestampsAndStringsDataTable = <T, U>({ data }: Props<T, U>) => {
  const i18n = useI18N();
  const texts = {
    noDataAvailable: i18n(
      "modules.timestampsAndStringsDataTable.noDataAvailable",
    ),
    timestampColumnHeaderText: i18n(
      "modules.timestampsAndStringsDataTable.timestampColumnHeaderText",
    ),
    dataColumnHeaderText: i18n(
      "modules.timestampsAndStringsDataTable.dataColumnHeaderText",
    ),
  };

  if (!data || data.length === 0) {
    return (
      <div>
        <p>{texts.noDataAvailable}</p>
      </div>
    );
  }

  return (
    <div className={styles[cssClassName]}>
      {data === undefined && (
        <div className={styles[`${cssClassName}__spinner-wrapper`]}>
          <Spinner />
        </div>
      )}

      {data !== undefined && data.length > 0 && (
        <div className={styles[`${cssClassName}__table-wrapper`]}>
          <table className={styles[`${cssClassName}__table`]}>
            <thead className={styles[`${cssClassName}__thead`]}>
              <tr className={styles[`${cssClassName}__tr`]}>
                <th className={styles[`${cssClassName}__th`]}>
                  {texts.timestampColumnHeaderText}
                </th>
                <th className={styles[`${cssClassName}__th`]}>
                  {texts.dataColumnHeaderText}
                </th>
              </tr>
            </thead>
            <tbody className={styles[`${cssClassName}__tbody`]}>
              {data.map((item, index) => (
                <tr
                  key={index}
                  className={`${styles[`${cssClassName}__tr`]} ${
                    index % 2 === 0
                      ? styles[`${cssClassName}__tr--even`]
                      : styles[`${cssClassName}__tr--odd`]
                  }`}
                >
                  <td className={styles[`${cssClassName}__td`]}>
                    {String(item.timestamp)}
                  </td>
                  <td className={styles[`${cssClassName}__td`]}>
                    {String(item.data)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
